import { parseOrderSizeColor } from './luxuryproFulfill';

const optionValues = (catalog, key) =>
  catalog?.options?.find((opt) => opt.option === key)?.values || [];

const matchExact = (values, raw) => {
  const text = String(raw || '').trim().toLowerCase().replace(/\s+/g, ' ');
  if (!text || !values?.length) return '';
  return values.find((value) => value.toLowerCase() === text)
    || values.find((value) => value.toLowerCase().replace(/^toddler\s+/, '') === text)
    || '';
};

export function resolveMerchize(catalog, orderItem, manualPicks = {}) {
  const { orderSize, orderColor } = parseOrderSizeColor(orderItem);
  const sizeValues = optionValues(catalog, 'size');
  const colorValues = optionValues(catalog, 'color');
  const picks = {
    size: manualPicks.size != null ? manualPicks.size : matchExact(sizeValues, orderSize),
    color: manualPicks.color != null ? manualPicks.color : matchExact(colorValues, orderColor),
  };
  const needsColor = colorValues.length > 1;
  const variant = (catalog?.variants || []).find((row) => {
    if (!picks.size || row.size !== picks.size) return false;
    if (needsColor && row.color !== picks.color) return false;
    return true;
  }) || null;

  return {
    picks,
    variant,
    merchize_sku: variant?.merchize_sku || '',
    orderSize,
    orderColor,
    matched: !!variant,
  };
}
